import {
  Page,
  Card,
  TextField,
  Button,
  Layout,
  Text,
  LegacyStack,
  Banner,
  Box,
  Link,
  Icon,
  Divider
} from "@shopify/polaris";
import { StoreIcon, CircleInformationIcon } from "@shopify/polaris-icons";
import { useState } from "react";
// import img from "../logo123.jpg"

export function Login() {
  const [shopUrl, setShopUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (!shopUrl) {
      alert("Please enter your Shopify store URL.");
      return;
    }

    await fetch('https://epi.infoshoreapps.com/index.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        shop: shopUrl,
      }),
    });


    setIsLoading(true);

    // Simulate API call
    setTimeout(() => {
      console.log("Submitted URL:", shopUrl);
      setIsLoading(false);
      // Add your actual login logic here
    }, 1000);
  };

  return (
    <Page fullWidth>
      <Layout>
        <Layout.Section>
          <div style={styles.container}>
            <div style={styles.logoContainer}>
              <img
                src={`https://infoshoreapps.com/apps/TestServerepi/cpnew/assets/logo123.jpg`}
                alt="eBay Professional Importer"
                style={styles.logo}
              />
            </div>

            <Card sectioned>
              <LegacyStack vertical spacing="loose">
                <Box paddingBlockEnd="4">
                  <Text variant="headingXl" as="h1" alignment="center">
                    eBay Professional Importer
                  </Text>
                  <Text variant="bodyMd" as="p" alignment="center" color="subdued">
                    Connect your Shopify store to start importing eBay listings
                  </Text>
                </Box>

                <Box paddingBlock="4">
                  <Banner
                    title="Import products from eBay to your Shopify store with just a few clicks."
                    tone="info"
                  >
                  </Banner>
                </Box>

                <Box paddingBlockStart="2">
                  <TextField
                    // label="Shopify Store URL"
                    placeholder="eg. myshop.myshopify.com"
                    value={shopUrl}
                    onChange={setShopUrl}
                    autoComplete="off"
                    helpText="Enter your Shopify store URL to get started"
                    prefix={<Icon source={StoreIcon} />}
                  />
                </Box>

                <Box paddingBlockStart="4">
                  <Button
                    variant="primary"
                    fullWidth
                    onClick={handleSubmit}
                    loading={isLoading}
                  >
                    Connect Store
                  </Button>
                </Box>
              </LegacyStack>
            </Card>

          </div>
        </Layout.Section>
      </Layout>
    </Page>
  );
}

const styles = {
  container: {
    maxWidth: 500,
    margin: "60px auto",
    textAlign: "center",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "20px"
  },
  logo: {
    width: "80px",
    height: "80px",
    borderRadius: "12px"
  },
  featurePoint: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px"
  },
  icon: {
    marginRight: "8px"
  }
};